import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  errorIconContainer: {
    width: 60,
    height: 60,
    alignSelf: 'center',
    padding: theme.spacing[2],
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundNegative,
  },
  errorDescription: {
    textAlign: 'center',
  },
  resetButton: {
    alignSelf: 'center',
    minWidth: 140,
  },
}));
